import { render, staticRenderFns } from "./anyChat_h5_idr.vue?vue&type=template&id=73d99ed4&scoped=true"
import script from "./anyChat_h5_idr.vue?vue&type=script&lang=ts"
export * from "./anyChat_h5_idr.vue?vue&type=script&lang=ts"
import style0 from "./anyChat_h5_idr.vue?vue&type=style&index=0&id=73d99ed4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d99ed4",
  null
  
)

export default component.exports